import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import API from "../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
  Row,
  Col,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Button, Input, Label,
} from "reactstrap"
import { withRouter } from "react-router"
import { Link } from "react-router-dom"
import { withTranslation } from "react-i18next"
import Select from "react-select";
import {Slide, toast, ToastContainer} from "react-toastify";

const DataTableBureauOrderAgentScolarite = props => {
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = useState(false)
  const [modalRefus, setModalRefus] = useState(false)
  const [id, setId] = useState("")
  const [numeroOrder, setNumeroOrder] = useState("");
  const [orders, setOrders] = useState([])
  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: "Next",
    prePageText: "Back",
    alwaysShowAllBtns: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )
  const Columns = () => [
    {
      dataField: "user",
      text: props.t("Agent"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "type",
      text: props.t("Type de demande"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "numero_ordre",
      text: props.t("Numéro d'order"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "file",
      text: props.t("Fichier"),
      sort: true,
      style: {textAlign: "center"},
      headerStyle: (colum, colIndex) => {
        return {textAlign: "center"}
      },
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
          imp === 1 ? (
              <i style={{color: "#955cd5", cursor: "pointer"}}
                 className="fas fa-file-download"
                 onClick={() => download(row)}
              ></i>
          ) : (
              <i style={{color: "#a7a3a3", cursor: "pointer"}}
                 className="fas fa-file-download"
              ></i>
          )
      ),
    },
    {
      dataField: "valider_bureaux_ordre",
      isDummyField: true,
      text: props.t("Etat"),
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
          row.valider_bureaux_ordre == 0 ? (
              <div style={{display: "flex", justifyContent: "center"}}><i style={{color: "#FF0000", cursor: "pointer"}}
                                                                          className="fas fa-spinner fa-pulse"></i></div>
          ) :  row.valider_bureaux_ordre == 1 && row.valider_agent == 1 && row.valider ==1 ? (
              <div style={{display: "flex", justifyContent: "center"}}>
                <i
                    style={{color: "green", cursor: "pointer"}}
                    className="fas fa-check-double"

                ></i>
              </div>
          ):row.valider_bureaux_ordre == 2 ?(
              <div style={{display: "flex", justifyContent: "center"}}>
                <i
                    style={{color: "red", cursor: "pointer"}}
                    className="fas fa-times"

                ></i>
              </div>
          ) : (
              <div style={{display: "flex", justifyContent: "center"}}>
                <i
                    style={{color: "red", cursor: "pointer"}}
                    className="fas fa-check"

                ></i>
              </div>
          )
      )
    },
    {
      dataField: "Validation",
      isDummyField: true,
      text: props.t("Validation"),
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
          add === 1 ?(
                  row.valider_bureaux_ordre == 0 ? (
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <i
                            style={{ color: "green", cursor: "pointer" }}
                            onClick={() => toggle(row.id)}
                            className="fas fa-check"
                        ></i>
                      </div>
                  ) :  row.valider_bureaux_ordre == 1 && row.valider_agent == 1 && row.valider ==1 ? (
                      <div style={{display: "flex", justifyContent: "center"}}>
                        <i
                            style={{color: "#80aed6", cursor: "not-allowed"}}
                            className="fas fa-check-double"

                        ></i>
                      </div>
                  ): row.valider_bureaux_ordre == 1 ?(
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <i
                            style={{ color: "#b7862e", cursor: "not-allowed" }}
                            className="fas fa-check"
                            title="Cete demande déja utilisé"
                        ></i>
                      </div>
                  ):(
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <i
                            style={{ color: "#ED6464", cursor: "not-allowed" }}
                            className="fas fa-times"
                            title="Cete demande déja utilisé"
                        ></i>
                      </div>
                  )
              ):(
              <div style={{display: "flex", justifyContent: "center"}}>
                <i
                    style={{color: "#a7a3a3", cursor: "not-allowed"}}
                    className="fas fa-times"
                ></i>
              </div>
          )

    },
    {
      dataField: "Dévalidation",
      isDummyField: true,
      text: props.t("Dévalidation"),
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
          add === 1 ? (
                  row.valider_agent == 0 &&  row.valider_bureaux_ordre == 1   ? (
                      <div style={{display: "flex", justifyContent: "center"}}>
                        <i
                            style={{color: "#ED6464", cursor: "pointer"}}
                            onClick={() => toggleRefus(row.id)}
                            className="fas fa-times"
                        ></i>
                      </div>
                  ):(
                      <div style={{display: "flex", justifyContent: "center"}}>
                        <i
                            style={{color: "#a7a3a3", cursor: "not-allowed"}}
                            className="fas fa-times"
                        ></i>
                      </div>
                  )
              ):(
              <div style={{display: "flex", justifyContent: "center"}}>
                <i
                    style={{color: "#a7a3a3", cursor: "not-allowed"}}
                    className="fas fa-times"
                ></i>
              </div>
          )

    },
  ]
  const { SearchBar } = Search
  const download = (row) => {
    API.post(
        "demande/scolarite/download",
        {
          id: row.id
        },
        { responseType: "blob" }
    ).then(res => {
      const contentDisposition = res.headers["content-disposition"];
      const match = /filename="(.+)"/.exec(contentDisposition);
      const fileName = match ? match[1] : `${row.file}`;
      const blob = new Blob([res.data], { type: res.data.type });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
  }
  const [add, setAdd] = useState(0);
  const [imp, setImp] = useState(0);
  useEffect(async () => {
    const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
    const typeArticleSubMenu = userAuth.find(user =>
        user.sous_menu.some(subMenu => subMenu.sous_menu === "Bureau d'order")
    );
    setAdd(typeArticleSubMenu.sous_menu[0].add)
    setImp(typeArticleSubMenu.sous_menu[0].imp)
    const res = await API.post("demande/scolarite/lists/scolarite",{annee_id}).then(res => {
      setOrders(res.data.DemandeScolarite)
    })
    setLoading(true)
  }, [])
  const toggle = id => {
    setModal(!modal)
    setId(id)
  }
  const toggleRefus = id => {
    setModalRefus(!modalRefus)
    setId(id)
  }
  const toggleDelete = async () => {
    if(numeroOrder == ""){
      setModal(true)
      toast.error("⛔ Numéro d'order obligatoire !", {
        containerId: "A",
      })
    }else{
      const res = await API.post("demande/scolarite/update/bureaux/ordre", {
        id: id,
        numero_ordre:numeroOrder,
        valider_bureaux_ordre:1
      }).then(res => {
        API.post("demande/scolarite/lists/scolarite",{annee_id}).then(res => {
          setOrders(res.data.DemandeScolarite)
        })
        setLoading(true)
      })
    }

  }
  const toggleDeleteRefus = async () => {
    const res = await API.post("demande/scolarite/update/bureaux/ordre", {
      id: id,
      numero_ordre: null,
      valider_bureaux_ordre: 2
    }).then(res => {
      API.post("demande/scolarite/lists/scolarite", {annee_id}).then(res => {
        setOrders(res.data.DemandeScolarite)
      })
      setLoading(true)
    })
  }
  useEffect(() => {
    setModal(false)
    setModalRefus(false)
  }, [orders])
  return (
    <React.Fragment>
      <div>
        {loading ? (
          <Row>
            <Col xs="12">
              <ToolkitProvider
                keyField="id"
                data={orders}
                columns={Columns()}
                search
                bootstrap4
              >
                {toolkitProps => (
                  <div>
                    <Col sm="4">
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <SearchBar {...toolkitProps.searchProps} />
                          <i className="bx bx-search-alt search-icon" />
                        </div>
                      </div>
                    </Col>
                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      noDataIndication={() => <NoDataIndication />}
                      striped={false}
                      bordered={false}
                      classes={"table align-middle table-nowrap"}
                      headerWrapperClasses={"table-light"}
                      hover
                      pagination={paginationFactory(pageOptions)}
                      {...toolkitProps.baseProps}
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Col>
          </Row>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {props.t("Chargement")}
            </h4>
          </div>
        )}
        <ToastContainer
            transition={Slide}
            enableMultiContainer
            containerId={"A"}
            position={toast.POSITION.TOP_RIGHT}
            autoClose={2500}
        />
      </div>
      <Modal isOpen={modal} toggle={toggle} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggle}
          tag="h4"
        >
          {props.t("Validation")} {props.t("de Demande Administrative")}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
              <Row>
                <Col lg="12">
                  <div className="mb-6">
                    <Label for="basicpill-firstname-input1">{"Numéro d'order "}</Label>
                    <Input
                        lg="6"
                        type="text"
                        className="form-control"
                        placeholder={props.t("Numéro d'order")}
                        onChange={e => setNumeroOrder(e.target.value)}
                    />
                  </div>
                </Col>

              </Row>
              <Row>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  {" "}
                  <Col lg="6">
                    <div className="text-center mt-4">
                      <button
                          type="button"
                          className="btn btn-primary "
                          onClick={toggleDelete}
                      >
                        CONFIRMER
                      </button>
                    </div>
                  </Col>
                </div>
              </Row>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalRefus} toggle={toggleRefus} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggle}
          tag="h4"
        >
          {props.t("Dévalidation")} {props.t("de Demande Administrative")}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >

            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleDeleteRefus}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  {props.t("Oui")}
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleRefus}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {props.t("Non")}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(DataTableBureauOrderAgentScolarite))
DataTableBureauOrderAgentScolarite.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
  t: PropTypes.any,
}
